import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Link,
  IconButton,
} from '@material-ui/core';
import RemoveIcon from '@material-ui/icons/Clear';
import { Formik } from 'formik';

// COMPONENTS
import PriceField from '@/components/Form/PriceField';

// UTILITY
import setYupValidationSchema from '@/utility/validationSchema/validationSchema';

// STYLES
import { DialogStyled } from './styles';

const initialFormData = {
  price: '',
};

const DialogChangePrice = ({ data, onSaveClick, onClose, ...props }) => {
  const [t] = useTranslation();

  const mainPrice = data.user_price ?? data.price;

  function handleSubmitForm(values) {
    onSaveClick(data, values.price);
    onClose();
  }

  function handleSaveFree() {
    onSaveClick(data, 0);
    onClose();
  }

  return (
    <DialogStyled className="dialog" fullWidth maxWidth="xs" onClose={onClose} {...props}>
      <Formik
        initialValues={{ ...initialFormData, price: mainPrice }}
        validationSchema={setYupValidationSchema('changePriceSchema', t)}
        onSubmit={handleSubmitForm}
        validateOnMount
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isValid }) => (
          <form onSubmit={handleSubmit} noValidate autoComplete="off">
            <DialogContent>
              <IconButton className="dialog__close-btn" onClick={onClose}>
                <RemoveIcon />
              </IconButton>
              <Typography className="m-b-15" variant="h5" align="center" component="p">
                {t('changePriceDialog.title', { name: data.name })}
              </Typography>
              <div className="dialog__price-field">
                <PriceField
                  label={t('inputs.price')}
                  name="price"
                  value={values.price}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.price && !!errors.price}
                  helperText={touched.price && errors.price}
                  autoFocus
                />
                <Link
                  type="button"
                  component="button"
                  onClick={handleSaveFree}
                  style={{ marginBottom: touched.price && !!errors.price ? '21px' : 0 }}
                >
                  {t('common.free')}
                </Link>
              </div>
            </DialogContent>
            <DialogActions>
              <Link type="button" component="button" color="initial" onClick={onClose}>
                {t('buttons.cancel')}
              </Link>
              <Button type="submit" color="primary" size="small" disabled={!isValid}>
                {t('buttons.save')}
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </DialogStyled>
  );
};

DialogChangePrice.defaultProps = {
  onClose: () => {},
  onSaveClick: () => {},
};

DialogChangePrice.propTypes = {
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  onSaveClick: PropTypes.func,
};

export default React.memo(DialogChangePrice);
